export default __webpack_public_path__ + "static/media/Logo.6bfd5d0d.png";